<mat-button-toggle-group class="weekday-toggle-group" multiple [formControl]="formControl">
  @for (weekday of weekdays; track $index) {
    <mat-button-toggle [value]='weekday'>
      {{ produceLabel(weekday) }}
    </mat-button-toggle>
  }
</mat-button-toggle-group>
